import {
  IGetDatabaseMigrationsRequest,
  IGetDatabaseMigrationsResponse,
  IRunDatabaseMigrationsRequest,
  IRunDatabaseMigrationsResponse,
} from "common247";
import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";

/**
 * Fetches all registered database schema migrations and their execution status.
 *
 * @param {FirebaseServices} fb - Initialized Firebase client services.
 * @returns {Promise<IGetDatabaseMigrationsResponse>} Migrations list and status.
 */
export async function getDatabaseMigrations(
  fb: FirebaseServices
): Promise<IGetDatabaseMigrationsResponse> {
  const result = await callFunction<
    IGetDatabaseMigrationsRequest,
    IGetDatabaseMigrationsResponse
  >(fb, "getDatabaseMigrationsFunc", {});
  return result;
}

/**
 * Executes all pending database schema migrations.
 *
 * @param {FirebaseServices} fb - Initialized Firebase client services.
 * @returns {Promise<IRunDatabaseMigrationsResponse>} Execution results and summary.
 */
export async function runDatabaseMigrations(
  fb: FirebaseServices
): Promise<IRunDatabaseMigrationsResponse> {
  const result = await callFunction<
    IRunDatabaseMigrationsRequest,
    IRunDatabaseMigrationsResponse
  >(fb, "runDatabaseMigrationsFunc", {});
  return result;
}
